/** Stable instance var written by the generic absorption primitive. */
export const ABSORPTION_READY_ROUND_KEY = '@cards/engine/absorption_ready/round';
export function hasUnitAttackPermission(state, instanceId, permission) {
    return state.effects.some((effect) => effect.scope.kind === 'unit'
        && effect.scope.instanceId === instanceId
        && effect.vars.attackPermission === permission);
}
export function ignoresSummoningDelay(state, instanceId) {
    const instance = state.instances[instanceId];
    return instance?.vars[ABSORPTION_READY_ROUND_KEY] === state.round
        || hasUnitAttackPermission(state, instanceId, 'ignore_summoning_delay');
}
//# sourceMappingURL=attackPermissions.js.map